// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul[data-v-5166a263] {\n  width: 100%;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\nh4[data-v-5166a263] {\n  font-size: 12pt;\n  font-weight: bold;\n  text-decoration: none;\n  display: block;\n  border-bottom: 3px double #333;\n  margin: 0 0 0.5em 0;\n  text-align: left;\n}\n.empty-placeholder[data-v-5166a263] {\n  color: #333;\n  font-size: 10pt;\n  font-style: italic;\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
